"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  _instance: true
};
exports._instance = void 0;

var _BasisTheory = require("./BasisTheory");

Object.keys(_BasisTheory).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _BasisTheory[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BasisTheory[key];
    }
  });
});

var _applications = require("./applications");

Object.keys(_applications).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _applications[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _applications[key];
    }
  });
});

var _tokens = require("./tokens");

Object.keys(_tokens).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _tokens[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _tokens[key];
    }
  });
});

/**
 * Default instance used to expose bundle in <script> tags. <br/>
 * Not meant to be used in Node environment.
 */
const _instance = new _BasisTheory.BasisTheory();

exports._instance = _instance;